import React, { useRef, useState } from 'react';
import { withTranslation } from 'react-i18next';

import Popout from 'components/popout';
import EditPanel from 'components/edit-panel';
import CanUser from 'components/can-user';

const CreateTaskList = ({ onSubmit, btnText, btnClassName = 'btn btn-block btn-medium btn-secondary', t }) => {
    const [visible, setVisible] = useState(false);
    const popoutCtrl = useRef();

    const handleClick = () => {
        popoutCtrl.current.show();
    }

    const handleShow = () => setVisible(true);
    const handleHide = () => setVisible(false);
    const handleCancel = () => popoutCtrl.current.hide();

    const handleSubmit = name => {
        onSubmit(name);
        popoutCtrl.current && popoutCtrl.current.hide();
    }

    return (
        <CanUser type="createTaskGroup">
            <div className="create-list">
                <div className="create-list-inner">
                    <button className={btnClassName + (visible ? ' selected' : '')} onClick={handleClick}>
                        { btnText ?? `+ ${t('actions.Add Status')}` }
                    </button>

                    <Popout
                        xAlign="left"
                        provideController={popoutCtrl}
                        onShow={handleShow}
                        onHide={handleHide}
                    >
                        <EditPanel
                            placeholder={`${t('actions.Add status name')}…`}
                            actionText={ t('common:Create') }
                            onSubmit={handleSubmit}
                            onCancel={handleCancel}
                            autoFocus={true}
                            noClose={true}
                        />
                    </Popout>
                </div>
            </div>
        </CanUser>
    )
}

export default withTranslation(['task', 'common'])(CreateTaskList);
